import { createFileRoute, linkOptions } from '@tanstack/react-router'
import type { CoverageResponse } from 'types'

import PolicySheetContent from '@/components/sheets/policy/policy-sheet-content'
import { policySheetPreload } from '@/components/sheets/policy/policy-sheet-preload'
import { ViewTransitionType } from '@/css/view-transition.types'

export const Route = createFileRoute('/app/data/policies/$uuid/')({
  component: RouteComponent,
  loader: ({ params, context: { queryClient } }) =>
    policySheetPreload(params.uuid, queryClient),
})

const coverageRowLink = (coverage: CoverageResponse) =>
  linkOptions({
    from: Route.fullPath,
    to: '/app/data/policies/$uuid/$coverageUuid',
    params: { coverageUuid: coverage.uuid },
    viewTransition: { types: [ViewTransitionType.SheetParentToChild] },
  })

// const insistenceRowLink = (insistence: InsistenceResponse) =>
//   linkOptions({
//     from: Route.fullPath,
//     to: '/app/data/policies/$uuid/$coverageUuid',
//     params: { coverageUuid: insistence.coverage.uuid },
//     viewTransition: { types: [ViewTransitionType.SheetParentToChild] },
//   })

function RouteComponent() {
  const { uuid } = Route.useParams()

  return (
    <PolicySheetContent
      policyUuid={uuid}
      coverageRowLink={coverageRowLink}
      // insistenceRowLink={insistenceRowLink}
    />
  )
}
